<template>
  <div class="quick-search border-right">
    <!-- <div class="quick-search-inner">
      <div class="input-group">
        <input
          type="text"
          class="form-control"
          v-on:blur="hideResults"
          placeholder="Quick Search"
          aria-label="Quick Search"
          v-model="search"
          @input="delayedSearchItems"
          @keyup.enter="searchItems"
        />
        <div class="input-group-append">
          <button
            class="btn btn-outline-secondary"
            type="button"
            v-on:blur="hideResults"
            @click="searchItems"
          >
            <i class="fa fa-search"></i>
          </button>
        </div>
      </div>
      <b-list-group v-if="showSearchResults" class="quick-search-results" @click="pickedResult()">
        <b-list-group-item variant="info" class="flex-column align-items-start" v-if="loadingSearch">
          <div class="d-flex w-100 justify-content-between">
            <h6 class="mb-1">Loading Results...</h6>
            <small></small>
          </div>
        </b-list-group-item>
        <b-list-group-item exact :to="searchResultLink(searchItem)" class="flex-column align-items-start" v-else-if="searchResultItems && searchResultItems.length"
        v-for="(searchItem, key) in searchResultItems" :key="key">
          <div class="d-flex w-100 justify-content-between">
            <h6 class="mb-1" v-html="highlightSearchQuery(searchItem.shortDescription)"></h6>
            <small v-if="searchItem.sideTag1">{{searchItem.sideTag1}}</small>
          </div>

          <p  v-if="searchItem.description" v-html="searchItem.description">
          </p>

          <small v-if="searchItem.sideTag2">{{searchItem.sideTag2}}</small>
        </b-list-group-item>
        <b-list-group-item variant="warning" class="flex-column align-items-start" v-else>
          <div class="d-flex w-100 justify-content-between">
            <h6 class="mb-1">No Search Results!</h6>
            <small></small>
          </div>
        </b-list-group-item>
      </b-list-group>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'HeaderQuickSearch',
  components: {
  },
  data() {
    return {
      loadingSearch: false,
      search: '',
      showSearchResults: false,
      searchResultItems: [],
      delayedSearchTracker: false
    };
  },
  methods: {
    pickedResult() {
      this.search = '';
      this.showSearchResults = false;
    },
    hideResults() {
      setTimeout(() => {
        this.showSearchResults = false;
      }, 300);
    },
    searchResultLink(searchItem) {
      if(searchItem.type == 'CustomerOrder') {
        return {
          name: 'Common.OrderDetails',
          query: {
            id: searchItem.orderId
          }
        };
      } else if(searchItem.type == 'WTOrder' || searchItem.type == 'POOrder') {
        return {
          name: 'PO.Edit',
          params: {
            id: searchItem.poId
          }
        };
      } else if(searchItem.type == 'ManualShipment') {
        return {
          name: 'ManualShipments.Edit',
          params: {
            id: searchItem.manualShipmentId
          }
        };
      }
      return {
        name: 'Common.Orders.Index'
      };
    },
    highlightSearchQuery(item) {
     let retItem = item;
      if (this.search) {
        let searchQueryWord = this.search.trim();
        if (searchQueryWord) {
          let searchQueryWordRegex = new RegExp(searchQueryWord, 'g');
          retItem = retItem.replace(
            searchQueryWordRegex,
            '<u>' + searchQueryWord + '</u>'
          );
        }
      }
     return retItem;
    },
    queryGeneralSearch(query) {
      if(query) {
        this.loadingSearch = true;
        $http.post('/api/common/search', {
          query: query
        }).then(response => {
          this.loadingSearch = false;
          this.showSearchResults = true;
          this.searchResultItems = response.data;
        }).catch((err) =>{
          console.error('Failed to run queryGeneralSearch', err)
        });
      } else {
        this.loadingSearch = false;
        this.showSearchResults = false;
        this.searchResultItems = []
      }
    },
    searchItems() {
      if(this.delayedSearchTracker) {
        clearTimeout(this.delayedSearchTracker);
      }
      if(this.search) {
        this.loadingSearch = true;
        this.showSearchResults = true;
      } else {
        this.loadingSearch = false;
        this.showSearchResults = false;
      }
      if(this.search) {
        this.queryGeneralSearch(this.search.trim());
      }
    },
    delayedSearchItems() {
      if(this.delayedSearchTracker) {
        clearTimeout(this.delayedSearchTracker);
      }
      if(this.search) {
        this.loadingSearch = true;
        this.showSearchResults = true;
      } else {
        this.loadingSearch = false;
        this.showSearchResults = false;
      }
      this.delayedSearchTracker = setTimeout(() => {
        if(this.search) {
          this.queryGeneralSearch(this.search.trim());
        } else {
        this.loadingSearch = false;
        this.showSearchResults = false;
      }
      }, 800);
    }
  }
};
</script>
